import { ModelRow } from "@mcleod/core"
import { SecondaryFilterProps } from "@mcleod/dispatch"

export enum CarrierDriverMessageTaskFilterType {
    UNREAD = 'unread',
    PENDING = 'pending',
    FAILED = 'failed',
    SCHEDULED = 'scheduled',
    ALL = 'all'
}

export class CarrierDriverMessageTaskFilter {
    static readonly UNREAD: SecondaryFilterProps = {
        id: CarrierDriverMessageTaskFilterType.UNREAD,
        caption: "Unread",
        filter: (row: ModelRow) => row.data["message_read"] !== "Y" && row.data["direction"] === "I"
    }

    static readonly PENDING: SecondaryFilterProps = {
        id: CarrierDriverMessageTaskFilterType.PENDING,
        caption: "Pending",
        filter: (row: ModelRow) => row.data["status"] === "P" && row.data["direction"] === "O" && row.data["cancelled_scheduled_message"] !== "Y"
    }

    static readonly FAILED: SecondaryFilterProps = {
        id: CarrierDriverMessageTaskFilterType.FAILED,
        caption: "Failed",
        filter: (row: ModelRow) => row.data["status"] === "F" && row.data["direction"] === "O"

    }

    static readonly SCHEDULED: SecondaryFilterProps = {
        id: CarrierDriverMessageTaskFilterType.SCHEDULED,
        caption: "Scheduled",
        filter: (row: ModelRow) => row.data["scheduled_message"] === "Y" && row.data["direction"] !== "I" && row.data["status"] !== "D" && row.data["status"] !== "F" && row.data["cancelled_scheduled_message"] !== "Y"
    }
}